//region block: pre-declaration
//endregion
function hostIsSecure() {
  return window.location.protocol === 'https:' || window.location.hostname === 'localhost';
}
//region block: exports
export {
  hostIsSecure as hostIsSecure158mk00139d4n,
};
//endregion

//# sourceMappingURL=secureSiteCheck.js.mjs.map
